<template>
  <AppDialog
    title="Premium feature"
    append-to-body
    :show="show"
    class="scheduled-reports-premium-feature-banner-dialog"
    @close="onClose"
  >
    <div class="enterprise-banner">
      <h5>Upgrade plans to gain access to scheduled reports</h5>
      <p class="contents">
        Scheduled reports allow you to set any report to recur on a daily, weekly or monthly basis. Automatically get
        the information you need, when you need it.
      </p>
      <div>
        <a
          class="btn btn-sm btn-primary"
          :href="upgradePlanLink"
        >
          Upgrade plan
        </a>
        <a
          class="btn btn-naked"
          href="https://support.hubstaff.com/new-pricing-and-plans/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Learn more about premium
        </a>
      </div>
    </div>
    <template #footer>
      <button
        class="btn btn-default"
        @click="onClose"
      >
        Close
      </button>
    </template>
  </AppDialog>
</template>

<script>
import { OrganizationsResource } from '~/resources';

export default {
  name: 'ScheduledReportsPremiumPromotionDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    organizationId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    upgradePlanLink() {
      return OrganizationsResource.plansLink({ id: this.organizationId });
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>
